import VoiceAgentActionsAPI from 'dashboard/api/voiceAgents/actions';
import { createStore } from '../captain/storeFactory';

export default createStore({
  name: 'VoiceAgentAction',
  API: VoiceAgentActionsAPI,
});
